/**
 * Home Page (Landing Page)
 * Main entry point showcasing recent blogs and calculators
 */
import { useEffect } from 'react';
import { Box } from '@mui/material';
import HeroMUI from '../components/home/HeroMUI';
import FeaturedBlogs from '../components/home/FeaturedBlogs';
import CalculatorGridMUI from '../components/home/CalculatorGridMUI';
import { useCustomTranslation } from '../hooks';
import { trackPageView } from '../utils/analytics';
import SEO from '../components/common/SEO';

export default function Home() {
  const { t, i18n } = useCustomTranslation();
  const isEnglish = i18n.language === 'en';

  useEffect(() => {
    trackPageView('/', 'Home - Calculator Suite');
    document.title = t('home.meta.title');
  }, [t]);

  const seoTitle = isEnglish
    ? 'PayWise365 - Free Mortgage & Loan Calculator Suite 2026 | Hong Kong'
    : 'PayWise365 - 免費按揭與負款計算機套裝 2026 | 香港';

  const seoDescription = isEnglish
    ? 'Free professional mortgage calculators for Hong Kong. Calculate monthly payments, partial repayments, loan affordability, rent vs buy, retirement planning & more. Instant results with detailed amortization schedules.'
    : '香港免費專業按揭計算機。計算每月供款、部分還款、借貸能力、租買比較、退休規劃等。即時結果和詳細還款時間表。';

  const seoKeywords = isEnglish
    ? 'mortgage calculator Hong Kong, 按揭計算機, loan calculator, house loan calculator HK, partial repayment calculator, 部分還款, loan affordability, rent vs buy, retirement planning, free calculator 2026'
    : '按揭計算機, 香港按揭, 負款計算器, 樓宇貸款計算機, 部分還款計算機, 借貸能力, 租買比較, 退休規劃, 免費計算機 2026';

  return (
    <Box>
      <SEO
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        canonicalUrl="https://www.paywise365.com/"
        ogType="website"
      />
      <HeroMUI />
      <FeaturedBlogs />
      <CalculatorGridMUI showAll={true} />
    </Box>
  );
}
